import store from "@/store/store";
import {
  InstallationModule,
  Material,
  FormattedDocument,
  FormattedDocumentItem,
  DynamicDocumentItemData
} from "@/types";

function getMeterType(id?: number) {
  const inverter: Material = store.getters["materials/meters/findItem"](id);
  return (inverter && `${inverter.brand} - ${inverter.model}`) || "Niet ingevuld";
}

function getBreakerStatus(data: DynamicDocumentItemData[]) {
  let associationData = data?.find(d => d.field === "meterAssociation");

  switch (associationData?.value) {
    case "error":
      return "Niet geslaagd";
    case "breakerOn":
      return "AAN";
    case "breakerOff":
      return "UIT";
    default:
      return "Onbekend";
  }
}

export default (mod: InstallationModule, data: DynamicDocumentItemData[]): FormattedDocument => {
  let optional: FormattedDocumentItem[] = [];
  let breakerStatus = getBreakerStatus(data);

  if (mod.type !== "METER_MAAS-REGULAR") {
    optional.push({
      type: "text",
      title: "Productie test",
      value: mod.flags?.hasProductionTest ? "Geslaagd" : "Niet uitgevoerd / niet geslaagd"
    });
  }

  return [
    {
      title: "Meter",
      items: [
        {
          type: "text",
          title: "Type meter",
          value: getMeterType(mod.data!.meterId)
        },
        {
          type: "text",
          title: "Serienummer",
          value:
            mod.data!.meterSerialNumbers!?.map(({ serialNumber }) => serialNumber).join(", ") ||
            "Niet ingevuld"
        },
        {
          type: "text",
          title: "Serienummer Enphase Gateway",
          value:
            mod
              .data!.meterSerialNumbersEnphaseGateway!?.map(({ serialNumber }) => serialNumber)
              .join(", ") || "Niet ingevuld"
        },
        {
          type: "text",
          title: "Serienummer Enphase Relay",
          value:
            mod
              .data!.meterSerialNumbersEnphaseRelay!?.map(({ serialNumber }) => serialNumber)
              .join(", ") || "Niet ingevuld"
        },
        {
          type: "text",
          title: "Breaker status",
          value: breakerStatus
        },
        ...optional
      ]
    }
  ];
};
